import { useLocation } from 'react-router-dom';
import type { RootState } from 'src/redux/store';
import { useSelector } from 'src/redux/store';

/**
 * The path the browser actually shows: the router's pathname, unless a new chat on
 * this very location has since swapped its URL to its server id (`usePromoteChatUrl`,
 * a swap the router never sees). Use it wherever "which page is open" matters —
 * active nav rows, the open-chat check on delete. Pure derivation, re-evaluated on
 * every navigation and every promotion.
 */
export const useCurrentPathname = (): string => {
  const { pathname, key } = useLocation();
  const promoted = useSelector(
    (state: RootState) => state.chatUi.promotedChatUrl
  );
  return promoted?.locationKey === key ? promoted.path : pathname;
};
